module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0005.ed1d0802.jpg";